import { render, staticRenderFns } from "./CategoriesNested.vue?vue&type=template&id=5b1dcb5a&"
import script from "./CategoriesNested.vue?vue&type=script&lang=js&"
export * from "./CategoriesNested.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports